import { BaseProxy } from '../base.proxy';
import { Injectable } from '@angular/core';
import { InvestorProfile } from '../../model/session/IInvestorProfile.model';
import { environment } from 'src/environments/environment';

@Injectable()
export class SessionProxy extends BaseProxy {
  getInvestors() {
    if (environment.feature.newApi === false) {
      return this._http.get<InvestorProfile[]>(`/ip/api/session/getinvestors`);
    } else {
      return this._http.get<InvestorProfile[]>(`/ip-api/api/investor`);
    }
  }

  getDefaultPage() {
    if (environment.feature.newApi === false) {
      return this._http.get<any>(`/ip/api/session/default/page`);
    } else {
      return this._http.get<any>(`/ip-api/api/session/default/page`);
    }
  }

  dataSettingVisiblity() {
    return this._http.get<boolean>(`/ip/api/session/data-setting/visiblity`);
  }
}
